'use strict';function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const DashsboardStatus=require('pulsar-dashboard-core/dist-es6/domain/dashboardStatus');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const moment=require('pulsar-utils/dist-es6/time/moment');
const ex=require('pulsar-utils/dist-es6/ex');let

Formatters=function(){function Formatters(){_classCallCheck(this,Formatters)}Formatters.
intervalDurationAsHours=function intervalDurationAsHours(interval,options){
return Formatters.timeSpanAsHoursAndMinutes(interval.duration,options)+' h';
};Formatters.

timeSpanAsHoursAndMinutes=function timeSpanAsHoursAndMinutes(timespan,options){
const hours=Math.floor(timespan.totalHours());

if(_.get(options,'colonless')){
return`${hours}h ${timespan.minutes}m`;
}

const leadingZeroes=_.get(options,'leadingZeroes');

return`${leadingZeroes?_.padStart(hours,leadingZeroes,'0'):hours}:${_.padStart(timespan.minutes,2,'0')}`;
};Formatters.

timeSpanAsMinutesAndSeconds=function timeSpanAsMinutesAndSeconds(timespan){
const minutes=Math.floor(timespan.totalMinutes());
return`${minutes}:${_.padStart(timespan.seconds,2,'0')}`;
};Formatters.

humanizedTimeSince=function humanizedTimeSince(earlier,later){
return moment(earlier).from(later,!0);
};Formatters.

humanizedTimeUntil=function humanizedTimeUntil(earlier,later){
return moment(earlier).to(later,!0);
};Formatters.

drivingIntervalLabel=function drivingIntervalLabel(trip){
return`Driving\n${Formatters.intervalDurationAsHours(trip)}`;
};Formatters.

dutyLabel=function dutyLabel(duty,use24Hour){
return`On Duty\n${Formatters.intervalInLocationTimeAmPm(duty,!0,use24Hour)}`;
};Formatters.

dutyLabelWithDefaultTimeZone=function dutyLabelWithDefaultTimeZone(timeZone,use24Hour){
return function(duty){return Formatters.dutyLabel({
start:duty.start,
end:duty.end,
startTimezone:duty.startTimezone||timeZone,
endTimezone:duty.endTimezone||timeZone},
use24Hour)};
};Formatters.

dutyLabelWithDefaultTimeZone_24Hour=function dutyLabelWithDefaultTimeZone_24Hour(timeZone){
return Formatters.dutyLabelWithDefaultTimeZone(timeZone,!0);
};Formatters.

sleepLabel=function sleepLabel(sleepInterval,use24Hour){let title=arguments.length>2&&arguments[2]!==void 0?arguments[2]:'Sleep';
return`${title} (${Formatters.timeSpanAsHoursAndMinutes(sleepInterval.duration,{colonless:!0})})\n${Formatters.intervalInLocationTimeAmPm(sleepInterval,!0,use24Hour)}`;
};Formatters.

sleepLabelWithDefaultTimeZone=function sleepLabelWithDefaultTimeZone(timeZone,use24Hour,title){
return function(sleepInterval){return Formatters.sleepLabel({
start:sleepInterval.start,
end:sleepInterval.end,
duration:sleepInterval.duration,
startTimezone:sleepInterval.startTimezone||timeZone,
endTimezone:sleepInterval.endTimezone||timeZone},
use24Hour,title)};
};Formatters.

sleepLabelWithDefaultTimeZone_24Hour=function sleepLabelWithDefaultTimeZone_24Hour(timeZone,title){
return Formatters.sleepLabelWithDefaultTimeZone(timeZone,!0,title);
};Formatters.

tripLabel=function tripLabel(use24Hour){let seperator=arguments.length>1&&arguments[1]!==void 0?arguments[1]:'\n';
return function(trip){return`${trip.origin.description} to ${trip.destination.description}${seperator}${Formatters.intervalInLocationTimeAmPm(trip,!0,use24Hour)}`};
};Formatters.

tripLabel_24Hour=function tripLabel_24Hour(){
return Formatters.tripLabel(!0);
};Formatters.

deviationLabel=function deviationLabel(deviation){
if(!_.exists(deviation)){
return'--';
}
return deviation>=0?`+${deviation}`:deviation;
};Formatters.

intervalInComputerTimeMilitary=function intervalInComputerTimeMilitary(interval){
const start=interval.start.toTimeString().substr(0,5);
const end=interval.end.toTimeString().substr(0,5);

return`${start} - ${end}`;
};Formatters.

intervalInLocationTimeAmPm=function intervalInLocationTimeAmPm(interval,displayTimeZone,use24Hour){
const start=Formatters.timeInLocale(interval.start,interval.startTimezone,displayTimeZone,use24Hour);
const end=Formatters.timeInLocale(interval.end,interval.endTimezone,displayTimeZone,use24Hour);

return`${start} - ${end}`;
};Formatters.

timeInLocale=function timeInLocale(time,timezone){let displayTimeZone=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!0;let use24Hour=arguments.length>3&&arguments[3]!==void 0?arguments[3]:!1;
return Formatters.formatInLocale(time,_getHourFormat(use24Hour),timezone,{displayTimeZone:displayTimeZone});
};Formatters.

monthDayYearInUtc=function monthDayYearInUtc(time){
if(!_.exists(time)){
return'--';
}

return _momentExpectingDate(time).utc().format('MM / DD / YYYY');
};Formatters.

monthDayAndTimeInLocale=function monthDayAndTimeInLocale(time,timezone,options){
return Formatters.formatInLocale(time,'MMM DD, h:mm A',timezone,options);
};Formatters.

formatInLocale=function formatInLocale(time,format,timezone){let options=arguments.length>3&&arguments[3]!==void 0?arguments[3]:{};
if(!_.exists(timezone)){
const offset=time.getTimezoneOffset()/-60;
return _momentExpectingDate(time).format(format)+` (GMT${offset>=0?'+':''}${offset})`;
}

const fixPosixStrings=/Etc\/GMT/.exec(timezone)!==null;
const formattingString=options.displayTimeZone?`${format} (${fixPosixStrings?'[GMT]':''}z)`:format;
const formatted=_momentExpectingDate(time).tz(timezone).format(formattingString);

return fixPosixStrings?
formatted.replace(/GMT([-+])0/,'GMT$1'):
formatted;
};Formatters.

overallTripLabel=function overallTripLabel(trip){
return`${trip.origin.city}, ${trip.origin.state} to ${trip.destination.city}, ${trip.destination.state}`;
};Formatters.

utcAxisTimeLabel=function utcAxisTimeLabel(time){

const format=time.getUTCHours()%12==0?'h A':'h:mm';
return _momentExpectingDate(time).utc().format(format);
};Formatters.

utcAxisTimeLabel_24Hour=function utcAxisTimeLabel_24Hour(time){
return _momentExpectingDate(time).utc().format(_getHourFormat(!0));
};Formatters.

localAxisTimeLabel=function localAxisTimeLabel(time){
return _momentExpectingDate(time).format(_getHourFormat(!1));
};Formatters.

timeAndFullDateInTimeZone=function timeAndFullDateInTimeZone(time,timezone){let use24Hour=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1;
return Formatters.formatInLocale(time,
`${_getHourFormat(use24Hour)} MMM D, YYYY`,
timezone,
{displayTimeZone:!1});
};Formatters.

timeAndFullDateInTimeZone_24Hour=function timeAndFullDateInTimeZone_24Hour(time,timezone){
return Formatters.timeAndFullDateInTimeZone(time,timezone,!0);
};Formatters.

timeAndFullDateInLocalTimeWithoutZone=function timeAndFullDateInLocalTimeWithoutZone(time){
return _momentExpectingDate(time).format('h:mm A MMM D, YYYY');
};Formatters.

formatFatigue=function formatFatigue(number){let placeholder=arguments.length>1&&arguments[1]!==void 0?arguments[1]:'--';
if(number>=50){
return'50+';
}

return ex(DashsboardStatus.truncateFatigue(number)).otherwise(placeholder);
};Formatters.

roundUpToInteger=function roundUpToInteger(number){
if(!_.exists(number)){
return void 0;
}

return Math.ceil(number);
};Formatters.

classFromThresholdStatus=function classFromThresholdStatus(thresholdStatus){
switch(thresholdStatus){
case ThresholdStatus.At:
return AtThresholdClassObject;
case ThresholdStatus.Above:
return AboveThresholdClassObject;}

};Formatters.

dutyStatusFromLastKnownStatus=function dutyStatusFromLastKnownStatus(lastKnownStatus){
let{onDuty:onDuty,onTrip:onTrip}=lastKnownStatus;
return onDuty&&onTrip?'Driving':onDuty?'On duty':'Off duty';
};Formatters.

cityStateFromLastKnownStatus=function cityStateFromLastKnownStatus(lastKnownStatus){
let{location:location}=lastKnownStatus;
return`${location.city}, ${location.stateCode}`;
};Formatters.

dayOfWeekInTimeZone=function dayOfWeekInTimeZone(time,timezone){
return Formatters.formatInLocale(time,'ddd',timezone,{displayTimeZone:!1});
};Formatters.

monthAndDayInTimeZone=function monthAndDayInTimeZone(time,timezone){let{fullMonth=!1,dayFirst=!1}=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};
let dayFormat='DD';
let monthFormat=fullMonth?'MMMM':'MMM';

let dayAndMonthFormat=dayFirst?`${dayFormat} ${monthFormat}`:`${monthFormat} ${dayFormat}`;

return Formatters.formatInLocale(time,dayAndMonthFormat,timezone,{displayTimeZone:!1});
};Formatters.

heatmapShortName=function heatmapShortName(personOrGroup){let maxChars=arguments.length>1&&arguments[1]!==void 0?arguments[1]:3;
if(personOrGroup.name.length<=maxChars){
return personOrGroup.name;
}

const nameToSplit=_.exists(personOrGroup,'firstName')&&_.exists(personOrGroup,'lastName')?
`${personOrGroup.firstName[0]} ${personOrGroup.lastName}`:
personOrGroup.name;

return nameToSplit.split(/\W+/g).slice(0,maxChars).map(function(s){return s[0]}).join('').toUpperCase();
};Formatters.

pluralizableCount=function pluralizableCount(baseLabel,count){
let result=`${count} ${baseLabel}`;
if(count!==1){
result+='s';
}
return result;
};Formatters.

fixedPercentOrNothing=function fixedPercentOrNothing(count,total){
if(total===0){
return'';
}
return`${(count/total*100).toFixed(2)}%`;
};Formatters.

valueWithPercentage=function valueWithPercentage(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}
const[count,totalCount,label='Event']=_.isString(args[1])?[args[0],void 0,args[1]]:args;
let result=`${Formatters.pluralizableCount(label,count)}`;

if(_.exists(totalCount)&&totalCount!==0){
result=`${result} (${Formatters.fixedPercentOrNothing(count,totalCount)})`;
}

return result;
};return Formatters}();


const AtThresholdClassObject={"at-threshold":!0};
const AboveThresholdClassObject={"above-threshold":!0};

const _momentExpectingDate=function(time){
if(moment.isMoment(time)){
return time;
}

if(!_.isDate(time)){
throw new Error('Formatter expects time argument to be a moment or Date!');
}

return moment(time);
};

const TwentyFourHourFormat='HH:mm';

const _getHourFormat=function(use24Hour){return use24Hour?TwentyFourHourFormat:'h:mm A'};

module.exports=Formatters;
module.exports.TwentyFourHourFormat=TwentyFourHourFormat;
//# sourceMappingURL=formatters.js.map
